import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "LevelTabs",
  data: function data() {
    return {
      currentLevel: "",
      levelList: [],
      privilege: [{
        id: "vip_key_course_discount",
        text: "会员专享课程",
        img: require("@/assets/images/vip/course.png")
      }, {
        id: "vip_key_package_discount",
        text: "会员专享套卷折扣",
        img: require("@/assets/images/vip/vip-discount.png")
      }, {
        id: "vip_key_special_exercises",
        text: "专项练习无限畅刷",
        img: require("@/assets/images/vip/special.png")
      }, {
        id: "vip_key_random_exercises",
        text: "随机练习无限畅刷",
        img: require("@/assets/images/vip/random.png")
      }, {
        id: "vip_key_free_combine",
        text: "自由组卷无限畅刷",
        img: require("@/assets/images/vip/free.png")
      }, {
        id: "vip_key_error_collect",
        text: "错题集无限畅刷",
        img: require("@/assets/images/vip/wrong.png")
      }],
      privilegeList: []
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/vip/all_vip_info");

            case 2:
              res = _context.sent;
              this.levelList = res.map(function (item) {
                return _objectSpread({}, item, {
                  id: item.id.toString()
                });
              });
              this.currentLevel = res && res.length > 0 ? res[0].id.toString() : "";
              _context.t0 = res && res.length > 0;

              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return this.handleClick();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    //这边调接口，将接口返回的数据传给父组件
    handleClick: function () {
      var _handleClick = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var res, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.get("/api/app/vip/vip_info/".concat(this.currentLevel));

              case 2:
                res = _context2.sent;
                data = res.attr_data || {}; //筛选出享受的特权折扣项

                this.privilegeList = this.privilege.map(function (item) {
                  var text = item.text;

                  if (item.id == "vip_key_package_discount" && data[item.id]) {
                    if (data[item.id].switch == 2) {
                      text = "会员专项套卷折扣";
                    } else {
                      text = "套卷练习无限畅刷";
                    }
                  }

                  return _objectSpread({}, item, {
                    switch: data[item.id] && data[item.id].switch,
                    text: text
                  });
                });
                this.privilegeList = this.privilegeList.filter(function (i) {
                  return i.switch && i.switch != 0;
                });
                this.$emit("callBack", this.currentLevel, res);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleClick() {
        return _handleClick.apply(this, arguments);
      }

      return handleClick;
    }()
  }
};